<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content" style="width: 100%">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('import') }} (CSV/SHP)</h5>
                    <button type="button" class="btn-close" @click="$emit('close')"></button>
                </div>
                <div class="modal-body">
                    <div v-if="importing" class="text-center py-4">
                        <div class="spinner-border text-primary mb-3" role="status"></div>
                        <div class="text-muted">{{ $t('importing') }}...</div>
                    </div>
                    <div v-else>
                        <div class="row g-2 mb-3">
                            <div class="col-md-12">
                                <label class="form-label small fw-bold">{{ $t('file') }}</label>
                                <input type="file" class="form-control form-control-sm" accept=".csv,.shp,.dbf,.shx,.prj,.cpg,.sbn,.sbx,.zip" @change="onFileSelected" multiple />
                            </div>
                         
                        </div>
                        <div v-if="errorMessage" class="alert alert-danger alert-sm py-2 mt-2">
                            {{ errorMessage }}
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-8">
                                <label class="form-label">{{ $t('tableName') }}</label>
                                <input v-model="tableName" class="form-control form-control-sm" />
                            </div>
                            <div class="col-md-4" v-if="fileType === 'csv'">
                                <label class="form-label small fw-bold">{{ $t('delimiter') }}</label>
                                <select class="form-select form-select-sm" v-model="delimiter">
                                    <option value=";">;</option>
                                    <option value=",">,</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="columns.length > 0">
                            <table class="table table-bordered table-sm">
                                <thead>
                                    <tr>
                                        <th>{{ $t('column') }}</th>
                                        <th>{{ $t('dataType') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="col in columns" :key="col.index">
                                        <td>{{ col.name }}</td>
                                        <td>
                                            <select v-model="col.dataType" class="form-select form-select-sm">
                                                <option value="nvarchar">String</option>
                                                <option value="int">Integer</option>
                                                <option value="decimal">Decimal</option>
                                                <option value="datetime">Date Time</option>
                                                <option value="bit">Boolean</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="$emit('close')" :disabled="importing">
                        {{ $t('cancel') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="submitImport" :disabled="!canCreateTable()">
                        {{ $t('import') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>

<script>
    import DataSpaceApi from '../../api/server/dataspace';

    export default {
        name: 'CsvImport',
        props: ['dataSpaceId'],
        data() {
            return {
                file: null,
                delimiter: ';',
                tableName: '',
                columns: [],
                previewRows: [],
                previewRowCount: 3,
                importing: false,
                errorMessage: '',
                fileType: '',
                files: []
            };
        },
        watch: {
            delimiter() {
                if (this.file) this.parseFile();
            }
        },
        methods: {
            parseFile() {
                const reader = new FileReader();
                console.log(reader)
                reader.onload = (e) => {
                    const header = e.target.result.split(/\r?\n/)[0].split(this.delimiter);
                    this.columns = header.map((name, index) => ({
                        index,
                        name: name.trim(),
                        dataType: 'nvarchar'
                    }));
                };

                reader.readAsText(this.file, 'utf-8');
            },
            onFileSelected(event) {
                this.files = Array.from(event.target.files);
                if (!this.files.length)
                    return;

                var ext = this.files[0].name.split('.').pop().toLowerCase();

                if (ext === 'csv') {
                    this.fileType = 'csv';
                    this.file = this.files[0];
                    this.tableName = this.file.name.replace(/\.[^.]+$/, '');
                    this.parseFile();
                } else {
                    this.fileType = 'shp';
                    this.file = null;
                    this.tableName = this.files[0].name.replace(/\.[^.]+$/, '');
                    this.columns = [];
                    this.previewRows = [];
                }
            },
            async submitImport() {
                this.importing = true;
                this.errorMessage = '';
                try {
                    const formData = new FormData();
                    formData.append('tableName', this.tableName.trim());
                    formData.append('fileType', this.fileType);

                    if (this.fileType === 'shp') {
                        this.files.forEach(f => formData.append('files', f));
                    } else {
                        formData.append('file', this.files[0]);
                        formData.append('delimiter', this.delimiter);
                        formData.append('columns', JSON.stringify(this.columns));
                    }

                    await DataSpaceApi.importTable(this.dataSpaceId, formData);
                    this.$emit('imported');
                } catch (error) {
                    this.importing = false;
                    var key = error?.response?.body?.message || 'unknownError';
                    this.errorMessage = this.$t(key);
                }
            },
            canCreateTable() {
                return !this.importing && !!this.tableName.trim();
            }
        }
    };
</script>